import React, { useState, useEffect } from "react";
import { Button, Modal, TextInput } from "flowbite-react";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebaseConfig"; // Import existing auth instance

const ResetPassword = ({ open }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      setError("");
      setSuccess("");
      setEmail("");
    }
  }, [open]);

  const handleResetPassword = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError("");
    setSuccess("");

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess("Password reset email sent successfully. Please check your inbox.");
      // Automatically redirect to login page after 3 seconds
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    navigate("/login");
  };

  return (
    <Modal show={true} size="md" onClose={handleClose} popup>
      <Modal.Header />
      <Modal.Body>
        <form onSubmit={handleResetPassword} className="space-y-6">
          <h3 className="text-h5 font-medium text-gray-900 dark:text-white">
            Reset Password
          </h3>
          {error && <div className="text-red-500 text-small">{error}</div>}
          {success && <div className="text-green-500 text-small">{success}</div>}
          <div>
            <div className="mb-2 block">
              <label htmlFor="email" className="text-small font-medium text-gray-900 dark:text-gray-300">
                Your email
              </label>
            </div>
            <TextInput
              id="email"
              type="email"
              placeholder="name@company.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          <div className="w-full">
            <Button 
              type="submit" 
              className="w-full bg-blue-500 hover:bg-blue-700"
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Send Password Reset Email"}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ResetPassword;